import { NgModule } from '@angular/core';
import { IndexedDbService } from './indexed-db.service';

@NgModule({
  providers: [
    IndexedDbService
  ],
})
export class IndexedDbModule {}
